export default __webpack_public_path__ + "static/media/audio-support.0e744ae2.mp3";